import { useEffect } from 'preact/hooks';
const useKeyEnter = (callback) => {
  const ENTER_KEY_CODE = 13;
  const onEnterKeyUp = (event) => {
    if (event.keyCode === ENTER_KEY_CODE) {
      event.preventDefault();
      callback();
    }
  };
  useEffect(() => {
    window.addEventListener('keyup', onEnterKeyUp);
    return () => {
      window.removeEventListener('keyup', onEnterKeyUp);
    };
  });
};

export default useKeyEnter;



// WEBPACK FOOTER //
// ./hooks/useKeyEnter.js